// @core/api/endpoints/subscription/get_product_bundle.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductBundleResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get product bundle details
 * Retrieves complete information about a product bundle including products, pricing, and discount configuration.
 * @public This endpoint does not require authentication
 */
export async function GetProductBundle(
  bundle_id: string,
  options?: RequestOptions
): Promise<ProductBundleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bundles/:bundle_id`;
  requestPath = requestPath.replace(':bundle_id', encodeURIComponent(bundle_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ProductBundleResponse>(requestPath, { ...requestOptions });
}
